<template>
  <CardFrame :bgColor="data.backgroundColor" hasDropShadow>
    <CardContainer>
      <CardHeaderContainer :layout="'inline'">
        <CardImage :imageSize="'inline'" :image="image" />
        <Title class="'text-left'" :headingTag="'h3'" :style="'h3'">
          {{ data.title }}
        </Title>
      </CardHeaderContainer>
      <Hr isEmbedded />
      <CardBodyContainer>
        <CardBody :textAlignment="'left'" :text="data.body"> </CardBody>
      </CardBodyContainer>
    </CardContainer>
  </CardFrame>
</template>

<script>
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardImage from "../../Atoms/Cards/CardImage.vue";
import CardHeaderContainer from "../../Atoms/Cards/CardHeaderContainer.vue";
import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardBody from "../../Atoms/Cards/CardBody.vue";
import CardButtons from "../../Atoms/Cards/CardButtons.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import Hr from "../../Atoms/Hr.vue";
import Title from "../../Atoms/Heading.vue";

export default {
  components: {
    CardBody,
    CardBodyContainer,
    CardButtons,
    CardContainer,
    CardImage,
    CardHeaderContainer,
    CardFrame,
    Hr,
    Title,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const image = props.data.hasOwnProperty("image")
      ? props.data.image
      : props.data.icon;

    return {
      image,
    };
  },
};
</script>
